const moduleName = 'googleMaps';

export function googleMaps() {

    const googleMapsUrl = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyC03k-vwMpPcMHdbUgDRJJM-C5QWXUC-AI&callback=initMap';

    if (!document.querySelector(`script[src="${googleMapsUrl}"]`)) {
        const scriptElement = document.createElement('script');
        const firstScriptElement = document.getElementsByTagName('script')[0];

        scriptElement.src = googleMapsUrl;
        firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
    }



    window.initMap = function() {
        Array.from(document.querySelectorAll('.js-google-maps')).forEach((self) => {
            if (self.dataset[moduleName + 'Init'] === 'true') return;
            self.dataset[moduleName + 'Init'] = true;

            const holder = self;
            const mapCenter = new google.maps.LatLng(+holder.dataset.lat, +holder.dataset.lng);
            const mapOptions = {
                zoom: 16,
                center: mapCenter,
                disableDefaultUI: true,
                styles: [{
                        "elementType": "geometry",
                        "stylers": [{
                            "color": "#f5f5f5"
                        }]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [{
                            "visibility": "off"
                        }]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#616161"
                        }]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [{
                            "color": "#f5f5f5"
                        }]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#bdbdbd"
                        }]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [{
                            "color": "#eeeeee"
                        }]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#757575"
                        }]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [{
                            "color": "#e5e5e5"
                        }]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#9e9e9e"
                        }]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [{
                            "color": "#ffffff"
                        }]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#757575"
                        }]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [{
                            "color": "#dadada"
                        }]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#616161"
                        }]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#9e9e9e"
                        }]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [{
                            "color": "#e5e5e5"
                        }]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [{
                            "color": "#eeeeee"
                        }]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [{
                            "color": "#c9c9c9"
                        }]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#9e9e9e"
                        }]
                    }
                ]
            };
            const map = new google.maps.Map(holder, mapOptions);
            const markerUrl = (window.devicePixelRatio > 1) ? holder.dataset.markerUrlRetina : holder.dataset.markerUrl;
            const markerImage = {
                url: markerUrl,
                size: new google.maps.Size(255, 92),
                scaledSize: new google.maps.Size(255, 92),
                anchor: new google.maps.Point(46, 92)
            };
            const marker = new google.maps.Marker({
                position: mapCenter,
                map: map,
                icon: markerImage
            });
        });
    };

}